import { Component, ContentChildren, forwardRef, Input, QueryList } from '@angular/core'
import { ConfiguratorSwitchOptionComponent } from '../configurator-switch-option/configurator-switch-option.component'
import { FormControlValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms'

@Component({
    selector: 'mg-configurator-switch',
    templateUrl: './configurator-switch.component.html',
    styleUrls: ['./configurator-switch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfiguratorSwitchComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ConfiguratorSwitchComponent),
            multi: true,
        },
    ],
})
export class ConfiguratorSwitchComponent extends FormControlValueAccessor {
    @ContentChildren(ConfiguratorSwitchOptionComponent)
    options: QueryList<ConfiguratorSwitchOptionComponent>

    @Input()
    showOnlySelected: boolean = false

    async validate(): Promise<ValidationErrors | null> {
        return this.value &&
            this.options &&
            this.options.find(itemValue => itemValue.value === this.value) !== undefined
            ? null
            : { value: 'no value set' }
    }
}
